"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var components_1 = require("@idp/duc/components");
var ui_components_1 = require("@idp/ui-components");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var utils_1 = require("@idp/ui-components/utils");
var styles = require("./RetailerOffer.scss");
var RetailOfferState_1 = require("./RetailOfferState");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var ReportingService_1 = require("../../../api/ReportingService");
var CartUtilFunctions_1 = require("../../../utils/CartUtilFunctions");
var UtilityFunctions_1 = require("../../../utils/UtilityFunctions");
var WirelessUtilFunctions_1 = require("../../../utils/WirelessUtilFunctions");
var RetailerOffer = /** @class */ (function (_super) {
    __extends(RetailerOffer, _super);
    function RetailerOffer(props) {
        var _this = _super.call(this, props) || this;
        _this.offerModalLegalObj = {};
        _this.promotionIdexist = false;
        _this.legalURL = null;
        _this.legalLinkText = null;
        _this.state = new RetailOfferState_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.dealerOffersCMS = WirelessUtilFunctions_1.getDealOffersCMSData();
        _this.showRetailerOffer = _this.showRetailerOffer.bind(_this);
        _this.showOfferDetails = _this.showOfferDetails.bind(_this);
        _this.displayOfferDetailsModal = _this.displayOfferDetailsModal.bind(_this);
        _this.handleOfferLink = _this.handleOfferLink.bind(_this);
        _this.showOfferModal = _this.showOfferModal.bind(_this);
        _this.closeOfferModal = _this.closeOfferModal.bind(_this);
        return _this;
    }
    RetailerOffer.prototype.showRetailerOffer = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var partnerSessionObject = JSON.parse(sessionStorage.getItem('partnerAttributes'));
        this.payload = UtilityFunctions_1.getCartResp();
        this.cmsContent = WirelessUtilFunctions_1.getWlsCmsData();
        this.wlsCart = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.wirelessCart;
        var partnerName = partnerSessionObject ? partnerSessionObject.partnerLegalName
            : (_c = (_b = this.wlsCart) === null || _b === void 0 ? void 0 : _b.partnerInfo) === null || _c === void 0 ? void 0 : _c.partnerName;
        var retailerLogo = '';
        var memberOffer = ((_d = this.cmsContent) === null || _d === void 0 ? void 0 : _d.memberOfferHeading) ? (_e = this.cmsContent) === null || _e === void 0 ? void 0 : _e.memberOfferHeading : 'Member offer:';
        var baseURL = window && window.location && window.location.protocol + "//" + window.location.host;
        if ((_g = (_f = this.props) === null || _f === void 0 ? void 0 : _f.losg) === null || _g === void 0 ? void 0 : _g.promotionReferences) {
            (_j = (_h = this.props) === null || _h === void 0 ? void 0 : _h.losg) === null || _j === void 0 ? void 0 : _j.promotionReferences.forEach(function (promoRef) {
                var _a, _b, _c, _d;
                if (promoRef === ((_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.promotion) === null || _b === void 0 ? void 0 : _b.id)) {
                    _this.retailerOffer = (_d = (_c = _this.props) === null || _c === void 0 ? void 0 : _c.promotion) === null || _d === void 0 ? void 0 : _d.displayName;
                }
            });
        }
        this.dealerOffersCMS.forEach(function (dealerOffer) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            var dealerId = dealerOffer === null || dealerOffer === void 0 ? void 0 : dealerOffer.offerId;
            var dealerOfferId = dealerId ? dealerId.substring(dealerId.indexOf('_') + 1, dealerId.length) : '';
            var promos = (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.promotion) === null || _b === void 0 ? void 0 : _b.promotionId;
            if ((((_d = (_c = _this.wlsCart) === null || _c === void 0 ? void 0 : _c.partnerInfo) === null || _d === void 0 ? void 0 : _d.dealerCode) === dealerOffer.dealerCode) && (promos === dealerOfferId)) {
                retailerLogo = dealerOffer.icon;
                if ((_e = dealerOffer.dealerOffersLegal) === null || _e === void 0 ? void 0 : _e.legalModalPath) {
                    _this.promotionIdexist = true;
                    _this.legalURL = (_g = (_f = dealerOffer.dealerOffersLegal) === null || _f === void 0 ? void 0 : _f.legalModalPath) === null || _g === void 0 ? void 0 : _g[0];
                    _this.legalLinkText = (_j = (_h = dealerOffer.dealerOffersLegal) === null || _h === void 0 ? void 0 : _h.legalShortPath) === null || _j === void 0 ? void 0 : _j.shortLegalLinkLabel;
                }
            }
        });
        return (React.createElement(React.Fragment, null,
            this.retailerOffer !== '' && this.retailerOffer !== undefined &&
                React.createElement("div", { className: this.props.isReawardCard ?
                        styles.retailerOfferContainerReward
                        : styles.retailerOfferContainer },
                    React.createElement("span", null,
                        retailerLogo &&
                            React.createElement("img", { src: baseURL + "/" + retailerLogo, alt: "retailer offer dealer logo", width: "50px", height: "20px" }),
                        !retailerLogo &&
                            React.createElement("span", { className: styles.partnerName },
                                " ",
                                partnerName,
                                " ")),
                    React.createElement("span", { className: styles.retailerOffer },
                        !this.props.isReawardCard &&
                            React.createElement("span", { className: styles.retailerOfferHeading },
                                " ",
                                memberOffer,
                                " "),
                        React.createElement("span", null, this.retailerOffer),
                        React.createElement("span", null, this.showOfferDetails()))),
            this.displayOfferDetailsModal()));
    };
    RetailerOffer.prototype.showOfferDetails = function () {
        var _this = this;
        if (this.promotionIdexist) {
            return (React.createElement(components_1.Link, { kind: "textPlain", 
                // tslint:disable-next-line: jsx-no-lambda
                onClick: function () {
                    _this.handleOfferLink(_this.legalURL, _this.offerModalLegalObj);
                }, testId: utils_1.default('Cart', 'Retail', 'OfferDetails'), className: styles.seeOfferDetails }, this.legalLinkText));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    RetailerOffer.prototype.displayOfferDetailsModal = function () {
        return (React.createElement(ui_components_1.Modal, { testId: utils_1.default('Cart', 'Modal', 'RetailOffers'), options: {
                center: true, className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                show: this.state.isOfferDetailOpened,
                showClose: true,
                size: ModalProps_1.ModalSizes.MEDIUM,
                tabIndex: 0,
            }, events: { onClose: this.closeOfferModal } },
            React.createElement("div", { className: styles.legalContainer },
                React.createElement("p", { dangerouslySetInnerHTML: {
                        __html: this.offerModalLegalObj.longtext,
                    } }))));
    };
    RetailerOffer.prototype.handleOfferLink = function (legalAEMUrl, legalContent) {
        var _this = this;
        if (legalAEMUrl) {
            CartUtilFunctions_1.getLegalIDPData(legalAEMUrl, legalContent, legalContent.longtext, legalContent.shorttext).then(function (response) {
                if (response.longtext) {
                    legalContent.longtext = response.longtext;
                    legalContent.showLegal = true;
                    _this.showOfferModal(legalContent.shortdesclinktext);
                }
            }).catch(function (err) {
                legalContent.showLegal = false;
            });
        }
    };
    RetailerOffer.prototype.showOfferModal = function (linkText) {
        this.reportingService.fireLinkClickWithOutPageLoad(linkText, ReportingService_1.PageUrls.CART_BOGO_SEE_OFFER_DETAILS_MODAL);
        this.setState({ isOfferDetailOpened: true });
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_BOGO_SEE_OFFER_DETAILS_MODAL);
    };
    RetailerOffer.prototype.closeOfferModal = function () {
        this.reportingService.firePageLoadEvent(CartUtilFunctions_1.getLinkClickBasekUrl());
        this.setState({ isOfferDetailOpened: false });
        this.reportingService.firePageLoadEvent(CartUtilFunctions_1.getLinkClickBasekUrl());
    };
    RetailerOffer.prototype.render = function () {
        return (React.createElement("div", null, this.showRetailerOffer()));
    };
    return RetailerOffer;
}(React.Component));
exports.default = RetailerOffer;
//# sourceMappingURL=RetailerOffer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/RetailerOffer/RetailerOffer.js
// module id = 222
// module chunks = 8